import React from "react";
import ContentLoader from "react-content-loader";

export default function PostNotFound({ title , height}) {
  return (
    <div className="content-loader" style={{ background: "rgb(243 243 243)", borderRadius: 24, marginTop:30 }}>
      <ContentLoader
        speed={2}
        width="100%"
        height={height?height:500}
        backgroundColor="#f6de97"
        foregroundColor="#ecebeb"
      >
        <text
          x="50%"
          y="50%"
          dominantBaseline="middle"
          textAnchor="middle"
          fontSize="30"
          fill="#333"
        >
          {title}
        </text>
      </ContentLoader>
    </div>
  );
}
